import { TaskStatus } from '@/services/ws-funnel/src/main/resources/rest-api';

import { TaskTableStatus } from '../../types';

export const TaskStatusMap: Record<TaskTableStatus, TaskStatus | undefined> = {
  [TaskTableStatus.ALL]: undefined,
  [TaskTableStatus.UNASSIGNED]: TaskStatus.NEW,
  [TaskTableStatus.IN_PROGRESS]: TaskStatus.IN_PROGRESS,
  [TaskTableStatus.SNOOZED]: TaskStatus.SNOOZED,
  [TaskTableStatus.DONE]: TaskStatus.DONE,
  [TaskTableStatus.ARCHIVED]: TaskStatus.ARCHIVED,
};
